import React, { useEffect, useState } from 'react';

import NewPartnerView from '../../views/NewPartnerViews';

const AddPartnerComponent = () => {
 
    return <NewPartnerView />;
   
};

export default AddPartnerComponent;
